import React from "react";
import "./TabContent.css";

const TabContent = ({ children, isMobile }) => {
  return (
    <div className={`tab-content ${isMobile ? "mobile" : "desktop"}`}>
      {children}
    </div>
  );
};

export default TabContent;
